import calendar from './calendar';
import catalogs from './catalogs';
import deliveryPlans from './delivery-plans';
import discounts from './discounts';
import listings from './listings';
import orders from './orders';
import products from './products';
import productsets from './productsets_v1';
import results from './results';
import subscriptions from './subscriptions';

export default {
  namespaced: true,
  modules: {
    catalogs,
    discounts,
    listings,
    orders,
    products,
    subscriptions,
    productsets,
    deliveryPlans,
    calendar,
    results,
  },
};
